import { CommonModule, DOCUMENT, isPlatformServer, ViewportScroller } from '@angular/common';
import { Component, effect, HostListener, inject, PLATFORM_ID, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { OffcanvasService } from './shared/services/offcanvas.service';
import { BotonWspComponent } from './shared/ui/boton-wsp/boton-wsp.component';
import { FooterComponent } from './shared/ui/footer/footer.component';
import { HeaderComponent } from './shared/ui/header/header.component';
import { MetodosdepagoComponent } from './shared/ui/metodosdepago/metodosdepago.component';
import { OffcanvasRigthComponent } from './shared/ui/offcanvas-rigth/offcanvas-rigth.component';
import { GetMenuWebService } from './shared/services/web/get-menus-web.service';
import { LoaderComponent } from './shared/ui/loader/loader.component';
import { Meta } from '@angular/platform-browser';
import { AuthWebService } from './shared/services/web/auth-web.service';
import { AuthService } from './shared/services/ecommerce/authService.service';
import { filter, startWith, map } from 'rxjs/operators';
// import { BuscardorhomeMobileComponent } from './shared/ui/buscardorhomemobile/buscardorhome-mobile.component';
import { EcommerceService } from './shared/services/ecommerce-state.service';
// import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import { GtmService } from './shared/services/gtm.service';

import { PopupService, PopupPayload } from './shared/services/popup.service';
import { Subscription } from 'rxjs';
import { PopupEscalas } from './shared/ui/popup-escalas/popup-escalas';
import { BuscardorhomeMobileComponent } from './shared/ui/buscardorhomemobile/buscardorhome-mobile.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import { BuscardorhomeMobileComponent } from './shared/ui/buscardorhomemobile/buscardorhome-mobile.component';

@Component({
	selector: 'app-root',
	standalone: true,
	imports: [
		RouterOutlet,
		HeaderComponent,
		MetodosdepagoComponent,
		FooterComponent,
		OffcanvasRigthComponent,
		BotonWspComponent,
		LoaderComponent,
		// BuscardorhomeMobileComponent
		PopupEscalas,
		CommonModule,
		// BuscardorhomeMobileComponent
		BuscardorhomeMobileComponent
	],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	isOffcanvasVisible = false;
	// private gtmService = inject(GtmService);
	private route = inject(ActivatedRoute);
	slug: string | null = null;
	private platform = inject(PLATFORM_ID);
	private document = inject(DOCUMENT);
	private meta = inject(Meta);
	private router = inject(Router);
	private offcanvasService = inject(OffcanvasService);
	private menusResponseApi = inject(GetMenuWebService);
	private loginToken = inject(AuthWebService);
	private viewportScroller = inject(ViewportScroller);
	private authService = inject(AuthService);
	breakpointObserver = inject(BreakpointObserver);
	menuPrincipal? = signal<any | undefined>([]);
	menuEnlaces? = signal<any | undefined>([]);
	menuEnlaces2? = signal<any | undefined>([]);
	MenuOffcanvasRigth? = signal<any | undefined>([]);
	menuRutasFrecuentes1? = signal<any | undefined>([]);
	menuRutasFrecuentes2? = signal<any | undefined>([]);
	private credentials = { username: 'lead', password: '12345' };
	public ecommerce = inject(EcommerceService);
	codigoSig: number = 0;
	viewBuscador = true;
	dato = '';

	popupVisible = false;
	popupPayload: PopupPayload | null = null;
	private sub: Subscription;
	isMobile = false;

	// isMobile = false;

	constructor(private popupService: PopupService) {
		// this.breakpointObserver.observe(['(max-width: 1024px)']).subscribe((result) => {
		// 	this.isMobile = result.matches;
		// });
		this.sub = this.popupService.open$.subscribe((payload) => {
			this.popupPayload = payload;
			this.popupVisible = !!payload;
		});

		this.router.events
			.pipe(
				filter((e) => e instanceof NavigationEnd),
				startWith(null), // obtiene valor también al cargar por primera vez
				map(() => {
					let r = this.route;
					while (r.firstChild) r = r.firstChild; // 👈 bajar hasta el hijo real
					return r.snapshot.paramMap.get('slug'); // 👈 aquí sí existe 'slug'
				})
			)
			.subscribe((s) => {
				this.slug = s;
			});
	}

	onPopupClosed() {
		this.popupService.close();
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
		// this.sub2.unsubscribe();
	}

	botonMasArriba(): boolean {
		const ciudadesRojas = ['huancayo'];
		return this.slug !== null && ciudadesRojas.includes(this.slug.toLowerCase());
	}

	ngOnInit() {
		this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
			this.isMobile = result.matches;
		});
		// console.log(this.dato, 'VALOROOOOOOOOOOOOOOOOOOOOOOOOOOO-');
		// this.authService.autoLogin(this.credentials).subscribe((token) => {
		// 	if (token) {
		// 		console.log('Token válido:', token);
		// 	} else {
		// 		console.log('Token expirado, se necesita nuevo login.');
		// 	}
		// });
		this.offcanvasService.isOffcanvasVisible$.subscribe((isVisible) => (this.isOffcanvasVisible = isVisible));
		if (!isPlatformServer(this.platform)) {
			const body = this.document.body;
			const canvas = this.document.getElementById('hs-offcanvas-right');
			this.router.events.subscribe((event) => {
				this.ecommerce.open(0);
				// this.updateCanonicalTag();
				if (event instanceof NavigationEnd) {
					const ruta = event.urlAfterRedirects;
					if (ruta === '/') {
						this.viewBuscador = false;
					} else if (ruta.startsWith('/pasajes-en-bus/')) {
						this.viewBuscador = false; // o true, según tu lógica
					} else {
						this.viewBuscador = true;
					}
					// this.gtmService.pushEvent('pageView', {
					// 	page: event.url // Envía la URL de la ruta actual
					// });
					// this.updateCanonicalTag();
					const backtrack = this.document.querySelector('#backtrack');
					canvas?.classList.remove('translate-x-0');
					backtrack?.remove();
					this.offcanvasService.setOffcanvasVisibility(false);
					body.style.removeProperty('overflow');
					this.viewportScroller.scrollToPosition([0, 0]);
				}
			});
		}
	}
	ngAfterViewInit() {
		// const script = document.createElement('script');
		// script.src = 'https://app.optibase.io/script.js';
		// script.setAttribute('data-public-api-key', 'd269565e-ae62-4261-af99-894d1e4a9b38');
		// document.head.appendChild(script);
		this.menusResponseApi.getMenus().subscribe((data) => {
			this.menuPrincipal!.set(data?.filter((menu) => menu.slug === 'menu-principal'));
			this.menuEnlaces!.set(data?.filter((menu) => menu.slug === 'menu-enlaces'));
			this.menuEnlaces2!.set(data?.filter((menu) => menu.slug === 'menu-enlaces-2'));
			this.MenuOffcanvasRigth!.set(data?.filter((menu) => menu.slug === 'menu-derecha-desktop'));
			this.menuRutasFrecuentes1?.set(data?.filter((menu) => menu.slug === 'rutas-frecuentes-1'));
			this.menuRutasFrecuentes2?.set(data?.filter((menu) => menu.slug === 'rutas-frecuentes-2'));
		});
	}
	// private updateCanonicalTag() {
	// 	const url = window.location.origin + this.router.url.split('?')[0];

	// 	// Elimina el canonical anterior si existe
	// 	const existingCanonical = this.document.querySelector('link[rel="canonical"]');
	// 	if (existingCanonical) {
	// 		existingCanonical.remove();
	// 	}

	// 	// Crea y agrega el nuevo canonical
	// 	const link: HTMLLinkElement = this.document.createElement('link');
	// 	link.rel = 'canonical';
	// 	link.href = url;
	// 	this.document.head.appendChild(link);
	// }
	// @HostListener('window:storage', ['$event'])
	// onStorageChange(event: StorageEvent) {
	// 	if (event.key === 'myAppOpened') {
	// 		// Se ha abierto otra pestaña y ha escrito en localStorage
	// 		// Entonces esta pestaña NO es la más nueva
	// 		alert('Hola');
	// 	}
	// }
	@HostListener('window:scroll', [])
	onWindowScroll() {
		if (!isPlatformServer(this.platform)) {
			const contenedor = this.document.getElementById('contenedores22');
			const buscador = this.document.getElementById('buscador');
			if (contenedor?.offsetTop) {
				if (window.scrollY >= contenedor.offsetTop - 92) {
					buscador?.classList.add('totototo');
					buscador?.classList.add('z-8');
				} else {
					buscador?.classList.remove('totototo');
					buscador?.classList.remove('z-8');
				}
			}
		}
	}

	// ngAfterViewInit(): void {
	// 	const script = document.createElement('script');
	// 	script.src = 'https://app.optibase.io/script.js';
	// 	script.setAttribute('data-public-api-key', 'd269565e-ae62-4261-af99-894d1e4a9b38');
	// 	document.body.appendChild(script);
	// }
}
